export default "__VITE_ASSET__CEH9ddFO__"